<template>
  <v-dialog :value="value" max-width="520" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="subtitle-1">{{ $tt('feed.addManualRecord') }}</v-card-title>
      <v-card-text>
        <v-select
          v-model="form.operation_type"
          :items="operationOptions"
          :label="$tt('customOperationType')"
          dense
          outlined
        />
        <v-text-field v-model="form.started_at" type="datetime-local" :label="$tt('feed.recordStart')" dense outlined />
        <!-- 終了日時 または 作業時間(分) のどちらでも入力可 (終了日時が優先) -->
        <v-row dense>
          <v-col cols="7">
            <v-text-field v-model="form.ended_at" type="datetime-local" :label="$tt('feed.recordEnd')" dense outlined />
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model.number="form.duration_min"
              type="number"
              min="0"
              :label="$tt('feed.recordDuration')"
              dense
              outlined
              :disabled="!!form.ended_at"
            />
          </v-col>
        </v-row>
        <v-text-field v-model="form.field_name" :label="$tt('customFieldHeader')" dense outlined counter="120" />
        <v-textarea v-model="form.memo" :label="$tt('feed.recordMemo')" rows="3" dense outlined counter="1000" />
        <v-file-input
          v-model="form.photoFiles"
          :label="$tt('feed.sharePhotos')"
          accept="image/*"
          multiple
          dense
          outlined
          prepend-icon="mdi-camera"
          :hint="$tt('feed.sharePhotosHint')"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">{{ $tt('customCancel') }}</v-btn>
        <v-btn color="primary" :loading="saving" :disabled="!canSave" @click="save()">
          {{ $tt('customSaveAction') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import feedApiClient from '@/lib/feed-api-client'
import i18n from '@/lib/i18n'
import Operation from '@/lib/operation'
import Toast from '@/lib/toast'

export default {
  name: 'ManualWorkDialog',
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      saving: false,
      form: {
        operation_type: null,
        started_at: '',
        ended_at: '',
        duration_min: null,
        field_name: '',
        memo: '',
        photoFiles: [],
      },
    }
  },
  computed: {
    operationOptions() {
      return Operation.getAvailableOperationTypesForOptions(i18n.getUserLang()).filter(o => o.value)
    },
    canSave() {
      return !!this.form.operation_type && !!this.form.started_at
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.form = {
          operation_type: null,
          started_at: '',
          ended_at: '',
          duration_min: null,
          field_name: '',
          memo: '',
          photoFiles: [],
        }
      }
    },
  },
  methods: {
    async save() {
      this.saving = true
      try {
        const photoIds = []
        for (const f of (this.form.photoFiles || []).slice(0, 4)) {
          const res = await feedApiClient.uploadPhoto(f)
          photoIds.push(res.data.id)
        }
        await feedApiClient.createManualRecord({
          kind: 'work',
          operation_type: this.form.operation_type,
          started_at: this.form.started_at,
          ended_at: this.form.ended_at || undefined,
          duration_min: !this.form.ended_at && this.form.duration_min ? this.form.duration_min : undefined,
          field_name: this.form.field_name || undefined,
          memo: this.form.memo,
          photo_ids: photoIds.length ? photoIds : undefined,
        })
        Toast.i18nSuccess('feed.recordCreated')
        this.$emit('input', false)
        this.$emit('saved')
      } catch (e) {
        console.error(e.response || e)
        Toast.i18nError('feed.shareFailed')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
